import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";

import { agolSyncService } from '../services/agolSyncService';

import { toastHelper } from '@/helpers/ToastHelper';

import syncNested from './syncNested.vue'

@Component({ components: { syncNested } })
export default class Index extends Vue {

    public tree: StepCall[] = [];

    public running: boolean = false;
    public fail: boolean = false;
    public rollback: boolean = false;

    async mounted() {
        await this.initTree();
    }

    public async sync() {
        this.running = true;
        this.fail = false;

        this.tree.forEach(node => {
            this.resetState(node);
        })

        await setTimeout(async () => {
            for (let idx = 0; idx < this.tree.length; idx++) {
                const node = this.tree[idx];
                if (!this.fail) {
                    await this.caller(node);
                }
            }

            this.running = false;
            if (!this.fail)
                toastHelper.success("La sincronizzazione dei dati su ArcGis Online (AGOL) è terminata con successo!");
            else
                toastHelper.error("Si è verificato un errore nella sincronizzazione dei dati su ArcGis Online (AGOL).<br>Contattare l'amministratore di sistema.");
        }, 500);
    }

    resetState(node: StepCall) {
        node.state = "queue";
        if (node.nested && node.nested.length > 0) {
            node.nested.forEach(child => {
                this.resetState(child);
            })
        }
    }

    public async initTree() {
        this.tree = [{
            action: "Verifica e creazione struttura dati",
            state: "queue",
            description: "Verifica e creazione struttura dati",
            count: () => null,
            call: () => agolSyncService.CheckAndCreateDbStructure()
        },
        {
            action: "Censimenti InSitu",
            state: "queue",
            description: "Sincronizzazione censimenti InSitu",
            count: () => null,
            call: () => agolSyncService.InSituSync(),
            nested: [
                {
                    action: "Aree omogenee",
                    state: "queue",
                    description: "Sincronizzazione aree omogenee",
                    count: () => null,
                    call: () => agolSyncService.AreaOmogeneaSync(),
                    nested: [{
                        action: "Aree boschi da seme",
                        state: "queue",
                        description: "Sincronizzazione aree boschi da seme",
                        count: () => null,
                        call: () => agolSyncService.AreaBoscoDaSemeSync(),
                        nested: [{
                            action: "Aree raccolta",
                            state: "queue",
                            description: "Sincronizzazione aree raccolta",
                            count: () => null,
                            call: () => agolSyncService.AreaRaccoltaSync(),
                            nested: [{
                                action: "Aree saggio",
                                state: "queue",
                                description: "Sincronizzazione aree saggio",
                                count: () => null,
                                call: () => agolSyncService.AreaSaggioSync(),
                                nested: [{
                                    action: "Rilievi cavallettamento",
                                    state: "queue",
                                    description: "Sincronizzazione rilievi cavallettamento",
                                    count: () => null,
                                    call: () => agolSyncService.ClasseDiametricaSync()
                                }, {
                                    action: "Rilievi ipsometrici",
                                    state: "queue",
                                    description: "Sincronizzazione rilievi ipsometrici",
                                    count: () => null,
                                    call: () => agolSyncService.PiantaCampioneSync()
                                }]
                            }]
                        }]
                    }]

                }, {
                    action: "Piante da seme/piante plus",
                    state: "queue",
                    description: "Sincronizzazione piante da seme/piante plus",
                    count: () => null,
                    call: () => agolSyncService.PiantaPlusSync()
                }
            ]

        }, {
            action: "Censimenti ExSitu",
            state: "queue",
            description: "Sincronizzazione censimenti ExSitu",
            count: () => null,
            call: () => agolSyncService.ExSituSync(),
            nested: [
                {
                    action: "Aree speriemntali",
                    state: "queue",
                    description: "Sincronizzazione aree speriemntali",
                    count: () => null,
                    call: () => agolSyncService.AreaSperimentaleSync(),
                    nested: [
                        {
                            action: "Aree per specie/provenienza",
                            state: "queue",
                            description: "Sincronizzazione aree per specie/provenienza",
                            count: () => null,
                            call: () => agolSyncService.AreaSpecieProvenienzaSync(),
                            nested: [{
                                action: "Piante da seme/da marze",
                                state: "queue",
                                description: "Sincronizzazione piante da seme/da marze",
                                count: () => null,
                                call: () => agolSyncService.PiantaSemeMarzeSync()
                            }]
                        }
                    ]
                }
            ]
        }
        ];
    }

    private async caller(node: StepCall): Promise<void> {
        node.state = "inprogress";
        await node.call().then(async () => {
            node.state = "done";
            if (node.nested && node.nested.length > 0) {
                // tslint:disable-next-line: prefer-for-of
                for (let idx = 0; idx < node.nested.length; idx++) {
                    const nest = node.nested[idx];
                    if (!this.fail) {
                        await this.caller(nest);
                    }
                }
            }
        }, async (e) => {
            node.state = "fail";
            node.error = e;
            this.fail = true;
        });
    }
}
